import { IconProps } from 'Components/Icon/Icon';

export enum ReportView {
	Dashboard = 'dashboard',
	Report = 'report'
}

export enum ReportTableTab {
	Users = 'users',
	Assignments = 'assignments',
	Courses = 'courses'
}

export enum FilterKey {
	Assignments = 'assignments',
	Courses = 'courses',
	Status = 'status',
	CourseType = 'courseType',
	Property = 'property',
	Group = 'group',
	Role = 'role',
	Recertification = 'recertification'
}

/**
 * Filters live on one of two rows: the always-visible primary row, or the row
 * revealed by "More filters".
 */
export enum FilterRow {
	Primary = 'primary',
	More = 'more'
}

export interface FilterOption {
	value: string;
	label: string;
}

export interface FilterDefinition {
	key: FilterKey;
	/** Label shown while nothing is selected — e.g. "All assignments". */
	label: string;
	/** Compact label used once a value is picked — e.g. "Asgn". */
	chipLabel: string;
	row: FilterRow;
	multiple: boolean;
	icon?: IconProps['type'];
	/** Static options. Server-driven filters get theirs injected at render. */
	options?: FilterOption[];
	/** Renders a vertical separator before this filter. */
	dividerBefore?: boolean;
}

export type FilterSelection = Record<FilterKey, string[]>;

export type FilterOptionsByKey = Partial<Record<FilterKey, FilterOption[]>>;

export enum KpiRating {
	Excellent = 'excellent',
	Good = 'good',
	Fair = 'fair',
	Poor = 'poor'
}

/** Headline figures behind the dashboard's KPI row. */
export interface TrainingKpis {
	courseCompletion: number;
	fullyTrainedUsers: number;
	activeCourses: number;
	totalCompletions: number;
}
